import { useState, useEffect } from "react";
import { load } from "@cashfreepayments/cashfree-js";
import api from "./api";

export const Payment = ({
  handleConfirmOrder,
  vendorDetails,
  selectedDeliveryAddress,
  totalAmount,   // 👈 ADD THIS PROP
}) => {
  const [cashfree, setCashfree] = useState(null);

  useEffect(() => {
    load({ mode: "sandbox" }).then(setCashfree);
  }, []);

  const getSessionId = async () => {
    try {
      if (!selectedDeliveryAddress) {
        alert("Please select a delivery address");
        return;
      }

      const orderRes = await api.get("/getNextOrderId");

      const payload = {
        vendorId: vendorDetails.vendorId,
        vendorName: vendorDetails.vendorName,
        mobile: vendorDetails.mobile,
        email: vendorDetails.email,
        total: totalAmount, // ✅ REQUIRED
        orderId: orderRes.data.newOrderNumber,
        deliveryAddress: selectedDeliveryAddress,
      };

      const res = await api.post("/payment", payload);

      if (res.data?.payment_session_id) {
        localStorage.setItem("orderId", res.data.order_id);
        return res.data.payment_session_id;
      }
    } catch (error) {
      console.error("Session error:", error);
    }
  };

  const verifyPayment = async () => {
    try {
      const orderId = localStorage.getItem("orderId");
      const res = await api.post("/verify", { orderId });

      if (res?.data) {
        handleConfirmOrder();
      }
    } catch (error) {
      console.error("Verify error:", error);
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();

    if (!cashfree) return;

    const sessionId = await getSessionId();
    if (!sessionId) return;

    cashfree
      .checkout({
        paymentSessionId: sessionId,
        redirectTarget: "_modal",
      })
      .then(() => {
        verifyPayment();
      });
  };

  return (
    <button
      className="confirm-btn"
      style={{ marginLeft: "20px" }}
      onClick={handleClick}
    >
      Pay Now
    </button>
  );
};
